import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-nfc-icon',
  templateUrl: './nfc.svg',
  styleUrls: ['./nfc-icon.component.scss'],
})
export class NfcIconComponent implements OnInit {
  @Input() strokeColor = 'black';

  constructor() {}

  ngOnInit() {}

}
